import { useRef, useState, useEffect } from "react";

import { LocalStorageKeys, localStorageManager } from "../utils/localStorageManager";

/**
 * Listens for the storage event, meaning that an item in local storage has changed. It checks to see if the
 * item that changed is the one we are watching, and if so, updates the state.
 */
export const useLocalStorageWatcher = (key: LocalStorageKeys) => {
    const [state, setState] = useState(localStorageManager.getItem(key));
    const previousState = useRef(localStorageManager.getItem(key));

    useEffect(() => {
        if (!localStorageManager.isLocalStorageAvailable) {
            return;
        }

        const onStorageChange = () => {
            const value = localStorageManager.getItem(key);
            if (previousState.current === value) {
                return;
            }

            setState((prevState) => {
                previousState.current = prevState;
                return value;
            });
        };

        window.addEventListener("storage", onStorageChange);
        return () => window.removeEventListener("storage", onStorageChange); // eslint-disable-line consistent-return
    }, [key]);

    return state;
};
